<div
    msCustomActiveState
    msHaptics="pick-tap"
    [class.selected]="state.selected"
    [class.offline]="state.locked || disableOdds"
    [class.line-switcher-current-selection]="lineSwitcherCurrentSelection$ | async"
    [msOptionIndicator]="enableOptionIndicator && !state.locked ? price : undefined"
    [msOptionIndicatorPriceId]="enableOptionIndicator && !state.locked ? priceId : undefined"
    [msAutomation]="pickId ? pickId.toString() : ''"
    (click)="pickClick()">
    <ng-content />
</div>
